var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center container video-container"},[_c('video',{staticClass:"col-10",attrs:{"src":require("../assets/" + this.source),"controls":"","poster":require('../assets/'+this.thumbnail)}})])}
var staticRenderFns = []

export { render, staticRenderFns }